import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryContent from './components/CategoryContent';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!slug || !category) {
    return (
      <>
        <Navbar />
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900">分类未找到</h1>
          <p className="mt-2 text-foreground-500">请选择有效的彩种分类</p>
        </div>
        <Footer />
      </>
    );
  }

  const categoryNames: Record<string, string> = {
    shuangseqiu: '双色球',
    daletou: '大乐透',
    fucai3d: '福彩3D',
    pailiesan: '排列三',
    qixingcai: '七星彩',
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb
        items={[{ label: categoryNames[slug] || slug, path: `/category/${slug}` }]}
      />
      <main>
        <CategoryContent slug={slug} />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${category.name} - 彩客网`,
            description: `${category.name}最新开奖数据、历史走势分析及专业资讯，${category.description}`,
            url: `https://www.caikewang.com/category/${slug}`,
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.caikewang.com',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: category.name,
                  item: `https://www.caikewang.com/category/${slug}`,
                },
              ],
            },
            isPartOf: {
              '@type': 'WebSite',
              name: '彩客网',
              url: 'https://www.caikewang.com',
            },
          }),
        }}
      />
    </>
  );
}